/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Avatar, Icon } from '@components/atoms'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

import { UserType } from '@schemas'

interface PropsType {
	user: UserType
	isChecked?: boolean
	showDepartmentName?: boolean
	style?: React.CSSProperties
	className?: string
	icon?: JSX.Element
}

/** 아바타 28 + 이름. 선택되면 아바타 자리가 ink 원 + 체크로 바뀐다 */
export const ListUserInfo = (props: PropsType) => {
	const { user } = props
	const isChecked: boolean = props.isChecked ?? false

	return (
		<View
			css={[style, { ...props.style }]}
			className={props.className ? props.className : ''}
		>
			<View className="userInnerView">
				{isChecked ? (
					<View className="checkView">
						<Icon name="check" className="check" />
					</View>
				) : (
					<Avatar
						className="userInfoAvatar"
						picture={user.profileImageUrl}
						name={user.name}
						color={user.profileColor === '' ? mono.lineSoft : user.profileColor}
						icon={props.icon}
						size={28}
					/>
				)}

				<View className="textView">
					<View className="nameView">
						<span className="name">{user.name}</span>
					</View>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',
	fontFamily: boFont.ui,

	'.userInnerView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: 10,
		width: '100%',

		'.textView': {
			minWidth: 0,

			'.nameView': {
				display: 'flex',
				alignItems: 'center',

				'.name': {
					margin: 0,
					fontSize: 13,
					fontWeight: 400,
					color: 'inherit',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				},
			},
		},

		'.checkView': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexShrink: 0,
			width: 28,
			height: 28,
			background: mono.ink,
			borderRadius: '50%',

			'.check': {
				fontSize: 16,
				color: '#FFFFFF',
			},
		},
	},
})
